import Player from "@vimeo/player";

export default function () {
  document.querySelectorAll(".video__thumbnail").forEach((button) => {
    button.addEventListener("click", () => {
      let video = document.querySelectorAll(".video");
      let liveMessage = document.querySelector(".js-video-message");

      if (video && video[0]) {
        video[0].classList.add("visible");
        button.classList.add("hidden");
        let iframe = video[0].querySelectorAll("iframe");

        if (iframe && iframe[0]) {
          let player = new Player(iframe[0]);
          player.play().then(() => {
            iframe[0].focus();
          });

          if (liveMessage) {
            liveMessage.textContent = "La vidéo est présentement affichée";
          }
        }
      }
    });
  });
}
